if (!customElements.get('gwp-progress')) {
  customElements.define('gwp-progress', class GwpProgress extends HTMLElement {
    static syncing = false;

    connectedCallback() {
      window.clearTimeout(this.syncTimeout);
      this.syncTimeout = window.setTimeout(() => this.syncGift(), 0);
    }

    disconnectedCallback() {
      window.clearTimeout(this.syncTimeout);
    }

    get variantId() {
      return Number(this.dataset.gwpVariantId);
    }

    get threshold() {
      return Number(this.dataset.gwpThreshold);
    }

    get sectionsToRender() {
      const sections = [
        {
          id: 'mini-cart',
          section: 'mini-cart',
          selector: '.shopify-section'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'mobile-cart-icon-bubble',
          section: 'mobile-cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];

      const mainCartItems = document.getElementById('main-cart-items');
      if (mainCartItems?.dataset.id) {
        sections.push({
          id: 'main-cart-items',
          section: mainCartItems.dataset.id,
          selector: '.js-contents'
        });
      }

      const mainCartFooter = document.getElementById('main-cart-footer');
      if (mainCartFooter?.dataset.id) {
        sections.push({
          id: 'main-cart-footer',
          section: mainCartFooter.dataset.id,
          selector: '.cart__footer'
        });
      }

      const cartLiveRegion = document.getElementById('cart-live-region-text');
      if (cartLiveRegion) {
        sections.push({
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        });
      }

      return sections;
    }

    async syncGift() {
      if (!this.variantId || !this.threshold || this.dataset.gwpAvailable !== 'true' || GwpProgress.syncing) {
        return;
      }

      GwpProgress.syncing = true;

      try {
        const cart = await this.getCart();
        const giftState = this.getGiftState(cart);

        if (giftState.qualifyingTotal >= this.threshold && giftState.quantity === 0) {
          await this.addGift();
        }
        else if (giftState.qualifyingTotal < this.threshold && giftState.quantity > 0) {
          await this.updateGift(0);
        }
        else if (giftState.qualifyingTotal >= this.threshold && giftState.quantity > 1) {
          await this.updateGift(1);
        }
      }
      catch (error) {
        console.error(error);
      }
      finally {
        GwpProgress.syncing = false;
      }
    }

    getGiftState(cart) {
      return cart.items.reduce((state, item) => {
        if (Number(item.variant_id) === this.variantId) {
          state.quantity += item.quantity;
          return state;
        }

        state.qualifyingTotal += item.final_line_price;
        return state;
      }, { qualifyingTotal: 0, quantity: 0 });
    }

    getCart() {
      return fetch(`${theme.routes.cart_url}.js`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      }).then((response) => response.json());
    }

    addGift() {
      const body = JSON.stringify({
        id: this.variantId,
        quantity: 1,
        properties: {
          _gwp: 'true'
        },
        sections: this.sectionsToRender.map((section) => section.section),
        sections_url: window.location.pathname
      });

      return fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => this.renderSections(parsedState));
    }

    updateGift(quantity) {
      const body = JSON.stringify({
        updates: {
          [this.variantId]: quantity
        },
        sections: this.sectionsToRender.map((section) => section.section),
        sections_url: window.location.pathname
      });

      return fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), body })
        .then((response) => response.json())
        .then((parsedState) => this.renderSections(parsedState));
    }

    renderSections(parsedState) {
      if (!parsedState.sections) return;

      this.sectionsToRender.forEach((section) => {
        const element = document.getElementById(section.id);
        const sectionHtml = parsedState.sections[section.section];
        if (!element || !sectionHtml) return;

        const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const source = parsedHtml.querySelector(section.selector);
        if (!source) return;

        if (section.selector === '.shopify-section') {
          element.innerHTML = source.innerHTML;
          return;
        }

        const target = element.querySelector(section.selector) || element;
        target.innerHTML = source.innerHTML;
      });
    }
  });
}
